import { Inject, Injectable } from '@angular/core';
import { BulkReferralDto } from 'src/app/profiles/shared/dto/bulk-referral-add.dto';
import { AuthService, EnvironmentService, HttpRequestService, LogService, NameValue, NotificationService, UtilService } from 'src/app/shared';
import { ServiceApiService } from 'src/app/shared/api/service-api.service';
import { WebsiteServiceApiService } from 'src/app/shared/api/website-service-api.service';
@Injectable({
  providedIn: 'root',
})
export class WebsiteServiceService {
  public constructor(private _apiService: WebsiteServiceApiService) {}

  public bulkLogReferrals(bulkReferralDto: BulkReferralDto) {
    return this._apiService.post('/website/v2/referral/bulklogreferrals', bulkReferralDto);
  }

  public getDirectorySpecialFields(): Promise<Array<NameValue>> {
    return this._apiService.get('/website/v2/listing/special-fields').then((specialFields) => {
      return specialFields.map((x: any) => new NameValue(x.Name, x.Value));
    });
  }
}
